<template>
  <div>
    <dashboard-header :text='$t("ui.deviceCaption")'/>
    <v-card
        elevation="0"
        class="card-border-10">

      <d-table
          class="pt-10 px-10"
          :table-data="items"
          :fields="fields"
          :loading="loading"
          :hide-search="true"
      />

    </v-card>
  </div>
</template>

<script>
import dTable from "../base/DataTable.vue";
import i18n from "../../lang/i18n";
import {API2} from "../../api";
import DashboardHeader from "../component/DashboardHeader";
import mixin from "../../mixin";

export default {
  components: {DashboardHeader, dTable},
  mixins: [mixin],
  data() {
    return {
      // table
      items: [],
      totalRows: null,
      optionParams: null,
    };
  },
  mounted() {
    this.onTab()
  },
  computed: {
    fields() {
      return [
        {value: "deviceId", text: i18n.t("nav.device")},
        {value: "status", text: i18n.t("ui.status")},
      ];
    },
  },
  methods: {
    onTab() {
      this.getItems(this.optionParams)
    },
    async getItems(optionParams) {
      if (!optionParams) optionParams = {}
      optionParams.tr = 600000 // 10 minutes in milliseconds
      this.optionParams = optionParams
      let res = await this.get(API2.ACTIVE_DEVICE, optionParams)
      if (!res) return

      for (let item of res) {
        item.status = item.isActive === 1
        item.statusText = item.isActive === 1 ? "ui.onWorking" : "ui.offline"
      }
      this.items = res
    },
  }
};
</script>

<style></style>
